import React from 'react';
import { Link } from 'react-router-dom';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
// styles
import { Wrapper } from './Form.styles';
// hooks
import { useForm } from 'react-hook-form';
import { useLogin } from '../Hooks/useLogin';
// validators
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from './formSchema';

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });
  const { loading, responseError, login } = useLogin();
  const handleLogin = (data) => {
    login(data.email, data.password);
  };

  return (
    <Wrapper>
      <Container>
        {responseError && <Alert variant={'danger'}>{responseError}</Alert>}
        {loading && (
          <div className={'my-3 text-center'}>
            <Spinner
              animation='border'
              variant='primary'
              className={'text-center'}
            />
          </div>
        )}
        <h1 className={'form-title'}>Login</h1>
        <Form onSubmit={handleSubmit(handleLogin)}>
          <Form.Group className='mb-3' controlId='formGroupEmail'>
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type='email'
              placeholder='Enter email'
              name='email'
              {...register('email', { required: true })}
              isInvalid={errors.email}
            />
            {
              <Form.Control.Feedback type='invalid'>
                {errors.email?.message}
              </Form.Control.Feedback>
            }
          </Form.Group>
          <Form.Group className='mb-3' controlId='formGroupPassword'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              type='password'
              placeholder='Password'
              name='password'
              {...register('password', { required: true })}
              isInvalid={errors.password}
            />
            {
              <Form.Control.Feedback type='invalid'>
                {errors.password?.message}
              </Form.Control.Feedback>
            }
          </Form.Group>
          <div className='d-grid gap-2 mx-5 mt-5 mb-3'>
            <Button size='lg' type='submit' disabled={loading}>
              Login
            </Button>
          </div>
        </Form>
        <div className={'text-end me-2'}>
          <Link to='/forgot-password' replace={true}>
            Forgot password?
          </Link>
        </div>
        <div className={'text-center mt-5 link-text'}>
          <h3>
            Dont have an account?{' '}
            <Link
              style={{ color: 'var(--brandSecondary)' }}
              className={'ms-2 link'}
              to='/sign-up'
              replace={true}
            >
              Sign Up
            </Link>
          </h3>
        </div>
      </Container>
    </Wrapper>
  );
};

export default LoginForm;
